(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hc-wish-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hc-wish-share')) {
    customElements.define('hc-wish-share', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.button = this.querySelector('button');
        this.label = this.button.querySelector('span');
        this.defaultLabel = this.label.textContent;
        this.status = this.querySelector('[role="status"]');
        this.manual = this.querySelector('.hc-wish__manual');
        this.button.hidden = false;
        this.button.addEventListener('click', () => this.share(), options);
        this.scope = this.closest('product-info');
        if (this.dataset.form && this.scope) {
          this.scope.addEventListener('change', event => {
            if (event.target.closest('variant-selects')) this.pending = true;
            if (event.target.name === 'id') this.pending = false;
            this.label.textContent = this.defaultLabel;
            this.status.textContent = '';
            this.manual.hidden = true;
          }, { ...options, capture:true });
        }
      }
      disconnectedCallback() { this.controller?.abort(); }
      getUrl() {
        const url = new URL(this.dataset.url);
        let variant = url.searchParams.get('variant');
        if (this.dataset.form) {
          const form = document.getElementById(this.dataset.form);
          const input = form?.querySelector('[name="id"]');
          if (this.pending || !input?.value || !/^\d+$/.test(input.value)) return null;
          variant = input.value;
        }
        url.search = '';
        url.hash = '';
        if (variant) url.searchParams.set('variant', variant);
        return url.href;
      }
      showManual(url) {
        this.manual.hidden = false;
        const input = this.manual.querySelector('input');
        input.value = url;
        input.focus();
        input.select();
        this.status.textContent = this.dataset.manual;
      }
      async copy(url) {
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(url);
          this.label.textContent = this.dataset.copied;
          this.status.textContent = this.dataset.copied;
        } catch { this.showManual(url); }
      }
      async share() {
        const url = this.getUrl();
        if (!url) { this.status.textContent = this.dataset.wait; return; }
        this.button.disabled = true;
        this.manual.hidden = true;
        this.status.textContent = '';
        try {
          const data = { title:this.dataset.title, url };
          const desktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          if (!desktopPointer && navigator.share && (!navigator.canShare || navigator.canShare(data))) {
            try { await navigator.share(data); }
            catch (error) { if (error.name !== 'AbortError') await this.copy(url); }
          } else await this.copy(url);
        } finally { this.button.disabled = false; }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
